exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn{display:inline-block;border:1px solid transparent;padding:10px 15px;border-radius:4px;color:#fff;text-align:center;cursor:pointer;font-size:14px;line-height:1.42857;white-space:nowrap}.btn,.btn:active,.btn:focus,.btn:focus:active,.btn:hover,.btn:link,.btn:visited{outline:none}.btn.btn-primary{background-color:#e65454}.btn.btn-primary:hover{background-color:#d44a4a;border-color:#e65454}.btn.btn-primary:active{background-color:#c9403f}.btn.btn-secondary{background-color:#44546a}.btn.btn-default{border:1px solid #999;color:#333}.btn.btn-default:hover{background-color:#f6f6f6}.btn.btn-default:active{background-color:#e6e6e6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/scss/common/btn.scss
// module id = 595
// module chunks = 2